import React, { Component } from 'react'

import { connect } from 'react-redux';

import { actions } from './redux';
import Meta from 'components/layout/Meta';
import classnames from "classnames";

class Honor extends Component {
  state = {
    title:'关于我们'
  }
  componentWillMount(){
    this.props.getHonor();
  }

  render() {
    const menuList = [
      {
        content:'公司介绍',
        link:'company'
      },
      {
        content:'股东介绍',
        link:'shareholder'
      },
      {
        content:'高管团队',
        link:'management'
      },
      {
        content:'公司荣誉',
        link:'honor'
      },
      {
        content:'社会责任',
        link:'responsibility'
      },
    ];

    let routerPathname= this.props.router.location.pathname.split('/')[2]

    return(
      <div className="companyIntroduction honor about_con">
        <Meta location={this.props.location} title="公司荣誉-关于我们"/>
        <div className="about_banner">
          <h3>关于我们</h3>
        </div>
        <div className="about_main">
          <ul className="about_nav">
            {
              menuList.map((item, idx )=> {
                return(
                  <li key={idx} className={classnames({'cur': routerPathname == item.link})}>
                    <a href={'/aboutUs/' + item.link }>{item.content}</a>
                  </li>
                )
              })
            }
          </ul>
          <div className="mgauto">
            <h3 className="cont_h3">
              <span>公司荣誉</span>
              <p>HONOR</p>
            </h3>
            <ul className="honor_ul">
              {this.props.imgArr.map((img, i) => {
                return (<li key={i}>
                  <div>
                    <img src={img.image} />
                  </div>
                  <strong>{img.title}</strong>
                </li>)
              })}
            </ul>
          </div>

        </div>

      </div>
    )
  }
}

function mapState(state) {
  return {
    imgArr: state.aboutUs.honors || []
  }
}

export default connect(mapState, actions)(Honor);



// WEBPACK FOOTER //
// ./modules/aboutUs/Honor.js